<div class="pt-6">
  <aiwyn-logo [height]="60" [extraClasses]="'client-logo'" (click)="goBack()"></aiwyn-logo>
</div>

<ng-container *ngIf="{ enableMagicLinkExperience: enableMagicLinkExperience$ | async } as cfg">
  <div *ngIf="cfg.enableMagicLinkExperience; else newAuthenticationBody" class="authentication-body authentication-body-extra p-6">
    <div class="green-banner">
      <h2 class="h2-500">
        To finish signing in,
      </h2>

      <h2 class="h2-500">
        check your inbox!
      </h2>

      <p class="body-500 color-gray-100 mt-2">
        We've sent a one-time sign-in link to
      </p>

      <p class="body-500 color-green-400">
        {{ emailAddress$ | async }}
      </p>
    </div>

    <p class="body-400 color-gray-100 pt-6">
      Having trouble finding the email? Try these tips:
    </p>

    <ul class="tips-list mt-4">
      <li class="body-300 color-gray-100">Give it a few minutes-some mail systems take a moment</li>
      <li class="body-300 color-gray-100">Check your spam or junk folder</li>
      <li class="body-300 color-gray-100">Make sure you spelled your email address correctly</li>
    </ul>

    <div class="mt-8 mb-8 w-100 login__hr"><span>OR</span></div>

    <button
      andButton
      color="secondary"
      size="large"
      class="w-100"
      (click)="switchToUsernamePasswordLoginFlow()"
    >
      Return to sign-in screen
    </button>

    <p class="color-red-200 small-300 text-align-center mt-4">
      Please note: Requesting multiple magic links will invalidate any links previously requested.
    </p>
  </div>

  <ng-template #newAuthenticationBody>
    <div class="authentication-body">
      <h2>Check your email</h2>

      <p class="body-300 color-gray-100 text-center">
        To sign in password-free, tap the button in the email sent to {{ emailAddress$ | async }}.
      </p>

      <p class="small-300">
        Can't find the email? Check your spam filter!
      </p>
    </div>

    <button
      *ngIf="!cfg.enableMagicLinkExperience"
      id="switch-login-flow-button"
      andButton
      color="hyperlink"
      class="p-0 fw-light"
      (click)="switchToUsernamePasswordLoginFlow()"
    >
      Sign in with a password instead
    </button>
  </ng-template>

  <app-full-client-portal-footer class="mt-6"></app-full-client-portal-footer>
</ng-container>
